import axios from 'axios';

const client = axios.create();

// API 주소를 다른 곳으로 사용함
client.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
// client.interceptors.request.use(
//   async (config) => {
//     config.baseURL = await getBaseUrl();
//     console.log(config.baseURL);
//     console.log(config.url);
//     return config;
//   },
//   (error) => Promise.reject(error),
// );
client.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(
    process.env.REACT_APP_AUTH_TOKEN_NAME!,
  );
  // console.log(accessToken);
  config.headers['Authorization'] = `Bearer ${accessToken}`;

  // console.log(client.defaults.baseURL);
  // console.log(config.headers['Authorization']);

  return config;
});

/*
function addUrlPrefix(url: string) {
  let urlHeader;
  if (process.env.NODE_ENV === 'production') urlHeader = 'https://api.';
  else urlHeader = 'http://api.';
  return urlHeader + url;
}


export async function getBaseUrl() {
  const subDomain = await window.localStorage.getItem('subDomain');
  console.log(subDomain);
  console.log(client.defaults.baseURL);
  const baseURL = client.defaults.baseURL;
  if (baseURL === undefined) return '';
  if (subDomain === '') return addUrlPrefix(baseURL);
  else return addUrlPrefix(subDomain + '.' + baseURL);
}
*/

// export async function getBaseUrl() {
//   const enterpriseId = await window.localStorage.getItem('enterpriseId');
//   // console.log(enterpriseId);
//   // console.log(client.defaults.baseURL);
//   // const baseURL = client.defaults.baseURL + `/enterprises/${enterpriseId}`;
//   // console.log(baseURL);
//   // return baseURL;

//   if (enterpriseId === '') {
//     return client.defaults.baseURL;
//   } else {
//     return client.defaults.baseURL + `/enterprises/${enterpriseId}`;
//   }
// }

export default client;
